import React from "react";
import { Tooltip } from "@/components/ui";

interface OwnProps {
  text: string | undefined;
  maxLength?: number;
}

type Props = OwnProps;

const AbbreviatedPopoverFC: React.FC<Props> = ({ text, maxLength = 30 }) => {
  return (
    text && (
      <>
        {text.length <= maxLength ? (
          text
        ) : (
          <Tooltip>
            <Tooltip.Trigger render={<span>{text.substring(0, maxLength)}...</span>} />
            <Tooltip.Content>{text}</Tooltip.Content>
          </Tooltip>
        )}
      </>
    )
  );
};

export const AbbreviatedPopover = AbbreviatedPopoverFC;
